import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { ServiceInformationProps } from '@/modules/Service/types'
import ServiceTechnical from '../../shared/ServiceTechnical'
import { createSSLColumns, type SSLRow } from './ssl-config'

const Information: React.FC<ServiceInformationProps> = ({ service }) => {
    const { t } = useTranslation()

    // Create columns with conditional visibility
    const columns = useMemo(() => {
        const cols = createSSLColumns(t)
        return cols.map((col) => ({
            ...col,
            hidden:
                col.key === 'service_stopped_date'
                    ? !service?.service_stopped_date
                    : col.hidden,
        }))
    }, [t, service?.service_stopped_date])

    // Create row data
    const rows = useMemo<SSLRow[]>(() => [service], [service])

    return (
        <div className="space-y-4">
            <DataTableCustomized<SSLRow>
                columns={columns}
                rows={rows}
                rowKey={(row) => String(row?.service_id)}
                size="small"
                resizable
                emptyMessage={t('no-data', { defaultValue: 'No data' })}
            />
            <ServiceTechnical service={service} />
        </div>
    )
}

export default Information
